import classNames from 'classnames';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '../Button';
import Input, { InputProps } from '../Input';
import './style.scss';

type IconAndButtonProps = {
  icon?: { src: string; alt?: string; hideOnFocus?: boolean };
  button?: { text: string; onClick: () => Promise<void>; disabled?: boolean; dataTestId?: string };
  isLoading?: boolean;
};

export type InputWithIconAndButtonProps = IconAndButtonProps & Omit<InputProps, 'onChange'>;

const InputWithIconAndButton = ({ icon, button, className, isLoading, ...rest }: InputWithIconAndButtonProps) => {
  const [focused, setFocused] = useState(false);
  const shouldHide = icon?.hideOnFocus && focused;
  const isIconVisible = icon && !shouldHide;

  return (
    <div
      className={classNames(className, 'custom__input', {
        'custom__input--focused': focused,
        'custom__input--icon': isIconVisible,
        'custom__input--icon-focused': isIconVisible && focused,
      })}
    >
      {isIconVisible && <img className="custom__input-icon" src={icon?.src} alt={icon?.alt ?? 'icon'} />}
      <Input
        {...rest}
        onFocus={e => {
          rest.onFocus?.(e);
          setFocused(true);
        }}
        onBlur={e => {
          rest.onBlur?.(e);
          setFocused(false);
        }}
      />
      {button && (
        <Button
          type="button"
          className="custom__input-btn"
          onClick={button.onClick}
          isLoading={isLoading}
          disabled={button.disabled}
          data-test-id={button.dataTestId}
        >
          <FormattedMessage id={button.text} />
        </Button>
      )}
    </div>
  );
};

export default InputWithIconAndButton;
